import { keyframes } from '@emotion/react';

export const FadeIn = keyframes`
  from {
    opacity: 0;
  }

  100% {
    opacity: 1;
  }
`;

export const SlideInTop = keyframes`
  from {
    transform: translateY(-50%);
  }
  100% {
    transform: translateY(0%);
  }
`;

export const SlideInLeft = keyframes`
  from {
    transform: translateX(-100%);
  }
  100% {
    transform: translateX(0%);
  }
`;

export const SlideInRight = keyframes`
  from {
    transform: translateX(100%);
  }
  100% {
    transform: translateX(0%);
  }
`;

export const ZoomIn = keyframes`
    from {
      opacity: 0;
      transform: scale3d(0.3, 0.3, 0.3);
    }
  
    50% {
      opacity: 1;
    }
`;

export const FlipX = keyframes`
  from {
    transform: perspective(400px) rotate3d(1, 0, 0, 90deg);
    animation-timing-function: ease-in;
    opacity: 0;
  }

  40% {
    transform: perspective(400px) rotate3d(1, 0, 0, -20deg);
    animation-timing-function: ease-in;
  }

  60% {
    transform: perspective(400px) rotate3d(1, 0, 0, 10deg);
    opacity: 1;
  }

  80% {
    transform: perspective(400px) rotate3d(1, 0, 0, -5deg);
  }

  to {
    transform: perspective(400px);
  }
`;

export const FlipY = keyframes`
  from {
    transform: perspective(400px) rotate3d(0, 1, 0, 90deg);
    animation-timing-function: ease-in;
    opacity: 0;
  }

  40% {
    transform: perspective(400px) rotate3d(0, 1, 0, -20deg);
    animation-timing-function: ease-in;
  }

  60% {
    transform: perspective(400px) rotate3d(0, 1, 0, 10deg);
    opacity: 1;
  }

  80% {
    transform: perspective(400px) rotate3d(0, 1, 0, -5deg);
  }

  to {
    transform: perspective(400px);
  }
`;
